module.exports = require('@apps-orangefi/i18n')
